// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b99d6e31","isCurrent":"_b3cba471","placeholder":"_9c5b4a81","thumb":"_95b9e4a4","icon":"_a7062dc9","iconWrapper":"_9abb83ba","frameOverlay":"_2a136ac5"};